import { createTheme } from '@mui/material'
import createPalette from '@mui/material/styles/createPalette'

export const COLOR_PRIMARY = '#F0C237' // blue
export const COLOR_SECONDARY = '#69716f' // dark blue light
export const COLOR_DANGER = '#e93f3f'
export const COLOR_WARNING = '#ff9f00'
export const COLOR_BGDISABLED = '#eee'

const rootElement = document.getElementById('root')

export const palette = createPalette({
    primary: { main: COLOR_PRIMARY, contrastText: '#525B69' },
    secondary: { main: COLOR_SECONDARY },
    error: { main: COLOR_DANGER },
    warning: { main: COLOR_WARNING },
})

export const theme = createTheme({
    palette,
    breakpoints: {
        values: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1280,
        },
    },
    typography: {
        fontSize: 16,
        fontFamily: ['JabloRegular, sans-serif'].join(','),
        allVariants: {
            color: '#525B69',
        },
    },
    components: {
        MuiPopover: {
            defaultProps: {
                container: rootElement,
            },
        },
        // MuiTextField: {
        //     styleOverrides: {
        //         root: {
        //             '& .Mui-disabled input': {
        //                 background: '#dcdcda',
        //                 overflow: 'hidden',
        //             },
        //         },
        //     },
        // },
        MuiPopper: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiDialog: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiModal: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiMenu: {
            defaultProps: {
                container: rootElement,
            },
        },
        MuiTabs: {
            styleOverrides: {
                scroller: {
                    paddingTop: '10px',
                },
                root: {
                    // marginLeft: '-20px',
                    // marginRight: '-20px',
                    '& .MuiTabs-indicator': {
                        display: 'none',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    color: '#69716f',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                textPrimary: {
                    color: '#fff',
                },
                textSecondary: {
                    color: '#000',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                filledWarning: {
                    text: '#fff',
                },
            },
        },
        MuiStepLabel: {
            defaultProps: {
                componentsProps: {
                    label: {
                        style: {
                            marginTop: 8,
                        },
                    },
                },
            },
            styleOverrides: {
                label: {
                    fontSize: '0.75rem',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '6px',
                },
                input: {
                    paddingTop: 16,
                    paddingBottom: 16,
                    fontSize: '1rem',
                },
                multiline: {
                    paddingTop: 16,
                    paddingBottom: 16,
                    fontSize: '1rem',
                },
            },
        },
    },
})

const components = theme.components

if (components) {
    components.MuiAutocomplete = {
        styleOverrides: {
            root: {
                [theme.breakpoints.down('lg')]: {
                    fontSize: '0.875rem',
                },
            },
        },
    }
    components.MuiSelect = {
        styleOverrides: {
            root: {
                [theme.breakpoints.down('lg')]: {
                    fontSize: '0.875rem',
                },
            },
            nativeInput: {
                [theme.breakpoints.down('lg')]: {
                    paddingTop: 12,
                    paddingRight: 14,
                    paddingBottom: 12,
                    paddingLeft: 14,
                },
            },
        },
    }
    components.MuiOutlinedInput = {
        styleOverrides: {
            root: {
                [theme.breakpoints.down('lg')]: {
                    fontSize: '0.875rem',
                },
            },
            input: {
                [theme.breakpoints.down('lg')]: {
                    paddingTop: 12,
                    paddingRight: 14,
                    paddingBottom: 12,
                    paddingLeft: 14,
                },
            },
        },
    }
    components.MuiInputLabel = {
        styleOverrides: {
            root: {
                [theme.breakpoints.down('lg')]: {
                    fontSize: '0.875rem',
                    transform: 'translate(14px, 13px) scale(1)',
                },
            },
            shrink: {
                [theme.breakpoints.down('lg')]: {
                    transform: 'translate(14px, -7px) scale(0.75)',
                },
            },
        },
    }
}
